import withActDetail from "../withActDetail";
import ActProductsForm from "./ActProductsForm";
import ActProductsPDFGenerator from "./ActProductsPDFGenerator";

const actFormKazakhName = 'Зерттеу жүргізуге тағам өнімдерін іріктеу АКТІСІ'
const actFormName = 'АКТ отбора пищевых продуктов на проведение исследования'
const actFormNumber = '007'
const actName = 'ActProducts'

export default withActDetail(ActProductsForm, ActProductsPDFGenerator, actFormKazakhName, actFormName, actFormNumber, actName)